import { z } from 'zod';
export const WorkspaceSchema = z.object({
    _id: z.string(),
    name: z.string(),
}).transform(({ _id, ...rest }) => ({ id: _id, ...rest }));
export const WorkspaceListResponseSchema = z.object({
    data: z.array(WorkspaceSchema),
});
export const WorkspaceResponseSchema = z.object({
    data: WorkspaceSchema,
});
